import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, AlertController } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

//PAGES
import { ViewEntregaPage } from '../view-entrega/view-entrega';
import { EntregasPage } from '../entregas/entregas';

//PROVIDERS
import { Services, Tools } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-conferencia',
  templateUrl: 'conferencia.html',
})
export class ConferenciaPage {
  entrega:any;
  confs:any=[];
  caixas:any=[];
  progress:any=0;
  total:any=0;
  concluidos:any=0;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private barcodeScanner: BarcodeScanner,
    private tools: Tools,
    public alertCtrl:AlertController,
    private platform: Platform,
    private services: Services
  ){}

  ionViewDidLoad(){
    this.entrega = this.navParams.get('item');

    if(!this.entrega.conferenciaList){
      this.caixas = this.entrega.caixas.map(e=>({caixa:e,status:'light'}));
    }else{
      this.caixas = this.entrega.conferenciaList;
    }
    this.calc();
  }

  conferir(idx:any){
    let loading = this.tools.showLoading('Carregando...');
    loading.present();

    this.barcodeScanner.scan().then(barcodeData => {
      barcodeData.text = barcodeData.text.toUpperCase();
      if(this.caixas[idx].caixa != barcodeData.text){
        this.tools.showAlert('toast','Código de incorreto.');
        loading.dismiss();
        return;
      }

      this.caixas[idx].status = 'primary'
      this.entrega.conferenciaList = this.caixas;

      this.services.save('cadRotas',this.entrega,(result)=>{
        this.calc();
        loading.dismiss();
      });
    }).catch(err => {
      loading.dismiss();
      console.log('Error', err);
    });
  }

  conferenciaManual(idx:any){
    let loading = this.tools.showLoading('Carregando...');
    loading.present();

    let alert = this.alertCtrl.create({
      title: 'Conferência manual',
      message: 'A conferência manual não é recomendada, utilize em último caso.\n\nCódigo: '+this.caixas[idx].caixa,
      enableBackdropDismiss:false,
      inputs: [
        {
          name: 'caixa',
          placeholder: 'Código caixa'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
            loading.dismiss();
            return;
          }
        },
        {
          text: 'OK',
          handler: data => {
            data.caixa = data.caixa.toUpperCase();
            if(this.caixas[idx].caixa != data.caixa){
              this.tools.showAlert('toast','Código de incorreto.');
              loading.dismiss();
              return;
            }

            this.caixas[idx].status = 'primary'
            this.entrega.conferenciaList = this.caixas;

            this.services.save('cadRotas',this.entrega,(result)=>{
              this.calc();
              loading.dismiss();
            });
          }
        }
      ]
    });
    
    alert.present();
  }

  confirmar(){
    let loading = this.tools.showLoading('Carregando...');
    loading.present();
    let check = this.caixas.find(e=>e.status == 'light');
    if(check){
      this.tools.showAlert('toast','Confirme a entrada de todas as caixas');
      loading.dismiss();
      return
    }

    this.entrega.conferencia = true;
    this.services.save('cadRotas',this.entrega,(result)=>{
      loading.dismiss();
      this.navCtrl.push(ViewEntregaPage,{item:this.entrega});
    });
  }

  calc(){
    this.concluidos = this.caixas.filter(e=>e.status == 'primary').length
    this.progress = ((100*this.concluidos/this.caixas.length)+'').split('.')[0];
    this.total = this.caixas.length;
  }

  voltar(){
    this.navCtrl.setRoot(EntregasPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/conferencia/conferencia.ts